import MenuItem from "components/common/MenuItem";
import Select from "@mui/material/Select";
import React, { useState } from "react";

import Text from "components/common/Text";

const CheckinAddDrawer = ({ data, handlecheckinsubmit, detail, visit_id ,checkInDetailsStatus}) => {
  
  const [formData, setFormData] = useState({
    station_id: detail.station_id,
    connector_id: "",
    date: "",
    time: "",
    units_charged: "",
    amount: "",
    visit_id: detail.id ?? visit_id,
    
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleConnectorChange = (e) => {
    setFormData({
      ...formData,
      connector_id: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault(); // Prevents the default form submission

    handlecheckinsubmit(formData);
    if(checkInDetailsStatus == 1 ){
      setFormData({
        connector_id: "",
        date: "",
        time: "",
        units_charged: "",
        amount: "",
      })
    }
  };

  return (
    <div style={styles.drawer}>
      <h2 style={styles.title}>Add Check-In details</h2>
      <form style={styles.form} onSubmit={handleSubmit}>
        <input
          type="text"
          name="stationName"
          value={detail.charging_station === "" ? "" : detail.charging_station}
          onChange={handleChange}
          style={styles.input}
        />
        <Text>Select Connector type</Text>
        <Select
          name="connector_id"
          placeholder="Select connector type name"
          value={formData.connector_id}
          onChange={handleConnectorChange}
          sx={{ fontSize: "14px", marginBottom: "10px" }}
        >
          {data?.connectors?.map((connector) => (
            <MenuItem
              sx={{ fontSize: "14px" }}
              key={connector.id}
              value={connector.id}
            >
              {connector.name}
            </MenuItem>
          ))}
        </Select>
        <input
          type="date"
          name="date"
          value={formData.date}
          onChange={handleChange}
          style={styles.input}
        />

        <input
          type="time"
          name="time"
          value={formData.time}
          onChange={handleChange}
          style={styles.input}
        />

        <input
          type="text"
          name="units_charged"
          placeholder="Unit charged"
          value={formData.units_charged}
          onChange={handleChange}
          style={styles.input}
          inputProps={{
            pattern: "[0-9]*([.,][0-9]*)?", // Allows for decimal numbers
            title: "Only numbers and decimal points are allowed",
          }}
          onInput={(e) => {
            const value = e.target.value
              .replace(/^\s+/, "") // Remove leading spaces
              .replace(/[^0-9.,]/g, "") // Remove any non-numeric characters except for decimal points
              .replace(/(\..*?)\..*/g, "$1"); // Ensure only one decimal point
            e.target.value = value;
          }}
        />
        <input
          type="text"
          name="amount"
          placeholder="Enter amount ₹"
          value={formData.amount}
          onChange={handleChange}
          style={styles.input}
          inputProps={{
            pattern: "[0-9]*([.,][0-9]*)?", // Allows for decimal numbers
            title: "Only numbers and decimal points are allowed",
          }}
          onInput={(e) => {
            const value = e.target.value
              .replace(/^\s+/, "") // Remove leading spaces
              .replace(/[^0-9.,]/g, "") // Remove any non-numeric characters except for decimal points
              .replace(/(\..*?)\..*/g, "$1"); // Ensure only one decimal point
            e.target.value = value;
          }}
        />
        <button disabled={!formData.amount} type="submit" style={styles.button}>
          Save
        </button>
      </form>
    </div>
  );
};

const styles = {
  drawer: {
    padding: "20px",
    width: "300px",
    backgroundColor: "#fff",
    borderRadius: "8px",
  },
  title: {
    margin: "0 0 20px 0",
    fontSize: "18px",
    fontWeight: "bold",
  },
  form: {
    display: "flex",
    flexDirection: "column",
  },
  input: {
    marginBottom: "10px",
    padding: "10px",
    fontSize: "16px",
    borderRadius: "4px",
    border: "1px solid #ddd",
  },
  button: {
    padding: "10px",
    fontSize: "16px",
    backgroundColor: "#28a745",
    color: "#fff",
    border: "none",
    borderRadius: "4px",
    cursor: "pointer",
  },
};

export default CheckinAddDrawer;
